import type { SVGProps } from "react";

export const InfoIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 9H12.01M11 12H12V16H13M3 12C3 13.1819 3.23279 14.3522 3.68508 15.4442C4.13738 16.5361 4.80031 17.5282 5.63604 18.364C6.47177 19.1997 7.46392 19.8626 8.55585 20.3149C9.64778 20.7672 10.8181 21 12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 9.61305 20.0518 7.32387 18.364 5.63604C16.6761 3.94821 14.3869 3 12 3C9.61305 3 7.32387 3.94821 5.63604 5.63604C3.94821 7.32387 3 9.61305 3 12Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export function InfoFilledIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C13.3132 2 14.6138 2.25917 15.827 2.76172C17.0402 3.26426 18.1429 4.00011 19.0714 4.9286C19.9999 5.8571 20.7357 6.95985 21.2383 8.17296C21.7408 9.38622 22 10.6868 22 12C22 13.3132 21.7408 14.6138 21.2383 15.827C20.7357 17.0402 19.9999 18.1429 19.0714 19.0714C18.1429 19.9999 17.0402 20.7357 15.827 21.2383C14.6138 21.7408 13.3132 22 12 22C10.6868 22 9.38622 21.7408 8.17296 21.2383C6.95985 20.7357 5.8571 19.9999 4.9286 19.0714C4.00011 18.1429 3.26426 17.0402 2.76172 15.827C2.25917 14.6138 2 13.3132 2 12C2 10.6868 2.25917 9.38622 2.76172 8.17296C3.26426 6.95985 4.00011 5.8571 4.9286 4.9286C5.8571 4.00011 6.95985 3.26426 8.17296 2.76172C9.38622 2.25917 10.6868 2 12 2ZM12 15.3333C11.3864 15.3333 10.8889 15.8308 10.8889 16.4444V16.4553C10.8889 17.0689 11.3864 17.5664 12 17.5664C12.6137 17.5664 13.1111 17.0689 13.1111 16.4553V16.4444C13.1111 15.8308 12.6137 15.3333 12 15.3333ZM12 7.55556C11.3864 7.55556 10.8889 8.05302 10.8889 8.66667V13.1111C10.8889 13.7248 11.3864 14.2222 12 14.2222C12.6137 14.2222 13.1111 13.7248 13.1111 13.1111V8.66667C13.1111 8.05302 12.6137 7.55556 12 7.55556Z"
        fill="currentColor"
      />
    </svg>
  );
}
